export default "<egeo-title title=\"Changelog\"></egeo-title>\n<div class=\"changelog\" [innerHTML]=\"changelog | MarkdownToHtml\"></div>\n"